import React, { useEffect, useMemo, useState } from 'react';
// import Login from './Login';
import CloseButton from './components/CloseButton';

function Menu({ open, onClose, onShowLogin, onShowWeather, onShowDiabetes, onShowHealthDataManager, onShowFoodIntake, onShowFoodTemplates, onShowMacroCalc, onShowGrafana, onShowGestas, onShowAngelicare, onShowMakro, onShowSelgros, onShowNoteLists, onShowCC, onShowBalanceAccounts, onShowCashflowExpenses, onShowCashflowTracker, onShowTaskLists, onShowEventLists, onShowBybit, onShowCyclicTasks, onShowMonthlyTasks, onShowMonthlyTaskAdder, onShowDriveInfo, loggedIn, setLoggedIn }) {
  const [activeSection, setActiveSection] = useState(null);
  const [activeSubSection, setActiveSubSection] = useState(null);

  // Always start from root when opening the menu
  useEffect(() => {
    if (open) {
      setActiveSection(null);
      setActiveSubSection(null);
    }
  }, [open]);

  const sections = useMemo(() => { 
    return [
      {
        id: 'health',
        label: '❤️ Health',
        enabled: loggedIn,
        items: [          
          {
            id: 'health-diabetes',
            label: '💉 Diabetes',
            onClick: typeof onShowDiabetes === 'function' ? onShowDiabetes : undefined,
            enabled: typeof onShowDiabetes === 'function'
          },
          {
            id: 'health-food-intake',
            label: '🍽️ Food intake',
            onClick: typeof onShowFoodIntake === 'function' ? onShowFoodIntake : undefined,
            enabled: typeof onShowFoodIntake === 'function'
          },
          {
            id: 'health-macro-calc',
            label: '🧮 Macro calc',
            onClick: typeof onShowMacroCalc === 'function' ? onShowMacroCalc : undefined,
            enabled: typeof onShowMacroCalc === 'function'
          },
          {
            id: 'health-food-templates',
            label: '📦 Food templates',
            onClick: typeof onShowFoodTemplates === 'function' ? onShowFoodTemplates : undefined,
            enabled: typeof onShowFoodTemplates === 'function'
          },
          {
            id: 'health-data-manager',
            label: '🩺 Data manager',
            onClick: typeof onShowHealthDataManager === 'function' ? onShowHealthDataManager : undefined,
            enabled: typeof onShowHealthDataManager === 'function'
          }
        ]
      },
      {
        id: 'organizacja',
        label: '📝 Organizacja',
        enabled: loggedIn,
        items: [          
          {
            id: 'zadania',
            label: '✅ Zadania',
            onClick: typeof onShowTaskLists === 'function' ? onShowTaskLists : undefined,
            enabled: typeof onShowTaskLists === 'function'
          },
          {
            id: 'wydarzenia',
            label: '📅 Wydarzenia',
            onClick: typeof onShowEventLists === 'function' ? onShowEventLists : undefined,
            enabled: typeof onShowEventLists === 'function'
          },
          {
            id: 'notatki',
            label: '📝 Notatki',
            onClick: onShowNoteLists,
            enabled: typeof onShowNoteLists === 'function'
          },
          {
            id: 'ustawienia',
            label: '⚙️ Ustawienia',
            onClick: () => setActiveSubSection('organizacja-ustawienia'),
            enabled: true
          }
        ]
      },
      {
        id: 'finanse',
        label: '💰 Finanse',
        enabled: loggedIn,
        items: [
          {
            id: 'karty',
            label: '💰 Karty',
            onClick: onShowCC,
            enabled: typeof onShowCC === 'function'
          },
          {
            id: 'salda',
            label: '💰 Salda',
            onClick: typeof onShowBalanceAccounts === 'function' ? onShowBalanceAccounts : undefined,
            enabled: typeof onShowBalanceAccounts === 'function'
          },
          {
            id: 'cashflow-expenses',
            label: '💸 Przepływy',
            onClick: typeof onShowCashflowExpenses === 'function' ? onShowCashflowExpenses : undefined,
            enabled: typeof onShowCashflowExpenses === 'function'
          },
          {
            id: 'cashflow-tracker',
            label: '💸 Tracker',
            onClick: typeof onShowCashflowTracker === 'function' ? onShowCashflowTracker : undefined,
            enabled: typeof onShowCashflowTracker === 'function'
          },
          {
            id: 'bybit',
            label: '💰 Bybit',
            onClick: typeof onShowBybit === 'function' ? onShowBybit : undefined,
            enabled: typeof onShowBybit === 'function'
          }
        ]
      },      
      {
        id: 'doc',
        label: '📄 Dokumenty',
        enabled: loggedIn,
        items: [
          {
            id: 'drive-info',
            label: '🗂️ Drive info',
            onClick: typeof onShowDriveInfo === 'function' ? onShowDriveInfo : undefined,
            enabled: typeof onShowDriveInfo === 'function'
          }
        ]
      },
      {
        id: 'display',
        label: '🖥️ Display',
        enabled: loggedIn,
        items: [
          {
            id: 'grafana',
            label: '📊 Grafana',
            onClick: typeof onShowGrafana === 'function' ? onShowGrafana : undefined,
            enabled: typeof onShowGrafana === 'function'
          },
          {
            id: 'gestas',
            label: '📊 Gestas',
            onClick: typeof onShowGestas === 'function' ? onShowGestas : undefined,
            enabled: typeof onShowGestas === 'function'
          },
          {
            id: 'angelicare',
            label: '💗 Angelicare',
            onClick: typeof onShowAngelicare === 'function' ? onShowAngelicare : undefined,
            enabled: typeof onShowAngelicare === 'function'
          },
          {
            id: 'makro',
            label: '🛒 Makro',
            onClick: typeof onShowMakro === 'function' ? onShowMakro : undefined,
            enabled: typeof onShowMakro === 'function'
          },
          {
            id: 'selgros',
            label: '🛒 Selgros',
            onClick: typeof onShowSelgros === 'function' ? onShowSelgros : undefined,
            enabled: typeof onShowSelgros === 'function'
          }
        ]
      }
    ];
  }, [loggedIn, onShowAngelicare, onShowBalanceAccounts, onShowBybit, onShowCC, onShowCashflowExpenses, onShowCashflowTracker, onShowDiabetes, onShowDriveInfo, onShowEventLists, onShowFoodIntake, onShowFoodTemplates, onShowMacroCalc, onShowGrafana, onShowGestas, onShowHealthDataManager, onShowMakro, onShowNoteLists, onShowSelgros, onShowTaskLists]);

  const activeSectionObj = useMemo(
    () => sections.find((s) => s.id === activeSection) || null,
    [sections, activeSection]
  );

  const activeSubSectionObj = useMemo(() => {
    if (activeSubSection === 'organizacja-ustawienia') {
      return {
        id: 'organizacja-ustawienia',
        label: '⚙️ Ustawienia',
        items: [          
          {
            id: 'cyclic-tasks',
            label: '🔁 Cykliczne',
            onClick: typeof onShowCyclicTasks === 'function' ? () => { setActiveSubSection(null); onShowCyclicTasks(); } : undefined,
            enabled: typeof onShowCyclicTasks === 'function'
          },
          {
            id: 'monthly-tasks',
            label: '🗓️ Miesięczne',
            onClick: typeof onShowMonthlyTasks === 'function' ? () => { setActiveSubSection(null); onShowMonthlyTasks(); } : undefined,
            enabled: typeof onShowMonthlyTasks === 'function'
          },
          {
            id: 'monthly-task-adder',
            label: '➕ Dodaj/miesiąc',
            onClick: typeof onShowMonthlyTaskAdder === 'function' ? () => { setActiveSubSection(null); onShowMonthlyTaskAdder(); } : undefined,
            enabled: typeof onShowMonthlyTaskAdder === 'function'
          }
        ]
      };
    }
    return null;
  }, [activeSubSection, onShowCyclicTasks, onShowMonthlyTaskAdder, onShowMonthlyTasks]);

  const buttonStyleBase = {
    margin: '10px 0',
    cursor: 'pointer',
    fontSize: '1.25rem',
    fontWeight: 700,
    borderRadius: 16,
    padding: '10px 0',
    textAlign: 'center'
  };

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: open ? 0 : '-240px',
      width: 240,
      height: '100vh',
      background: '#222',
      color: '#fff',
      transition: 'left 0.3s',
      zIndex: 1000,
      boxShadow: open ? '2px 0 12px rgba(0,0,0,0.2)' : 'none',
      display: 'flex',
      flexDirection: 'column',
      paddingTop: 24
    }}>
      <CloseButton
        onClick={onClose}
        style={{
          position: 'absolute',
          top: 10,
          right: 10,
          zIndex: 1001
        }}
        ariaLabel="Close menu"
      />
      <div style={{ padding: 16, marginTop: 64, flex: 1, display: 'flex', flexDirection: 'column' }}>
        {activeSectionObj ? (
          <>
            <div
              style={{
                ...buttonStyleBase,
                margin: '0 0 22px 0',
                color: '#fff',
                background: 'rgba(255,255,255,0.10)',
                textAlign: 'left',
                padding: '10px 12px'
              }}
              onClick={() => {
                if (activeSubSectionObj) {
                  setActiveSubSection(null);
                } else {
                  setActiveSection(null);
                }
              }}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  if (activeSubSectionObj) {
                    setActiveSubSection(null);
                  } else {
                    setActiveSection(null);
                  }
                }
              }}
              ariaLabel="Back"
            >
              ← Back
            </div>

            <div style={{
              opacity: 0.9,
              fontWeight: 800,
              letterSpacing: 0.3,
              margin: '6px 0 12px 0',
              padding: '0 2px'
            }}>
              {activeSubSectionObj ? activeSubSectionObj.label : activeSectionObj.label}
            </div>

            {(activeSubSectionObj ? activeSubSectionObj.items : activeSectionObj.items)
              .filter((it) => it.enabled !== false)
              .map((it) => (
                <div
                  key={it.id}
                  style={{
                    ...buttonStyleBase,
                    color: '#fa0',
                    background: 'rgba(255,170,0,0.08)'
                  }}
                  onClick={() => {
                    if (typeof it.onClick === 'function') it.onClick();
                  }}
                >
                  {it.label}
                </div>
              ))}
          </>
        ) : (
          <>
            <div
              style={{
                ...buttonStyleBase,
                color: '#6cf',
                background: 'rgba(100,200,255,0.08)'
              }}
              onClick={onShowWeather}
            >
              🌤️ Pogoda
            </div>
            {loggedIn && (
              <>
                {sections
                  .filter((s) => s.enabled !== false)
                  .map((s) => (
                    <div
                      key={s.id}
                      style={{
                        ...buttonStyleBase,
                        color: '#fa0',
                        background: 'rgba(255,170,0,0.08)'
                      }}
                      onClick={() => {
                        setActiveSection(s.id);
                        setActiveSubSection(null);
                      }}
                    >
                      {s.label} →
                    </div>
                  ))}
              </>
            )}

          </>
        )}
        <div style={{ flex: 1 }} />
        {!loggedIn && (
          <div
            style={{
              margin: '10px 0 24px 0',
              cursor: 'pointer',
              color: '#0ff',
              fontSize: '1.25rem',
              fontWeight: 700,
              borderRadius: 16,
              padding: '10px 0',
              textAlign: 'center',
              background: 'rgba(0,255,255,0.08)'
            }}
            onClick={onShowLogin}
          >
            🔐 Zaloguj
          </div>
        )}
        {loggedIn && (
          <div
            style={{
              margin: '10px 0 24px 0',
              cursor: 'pointer',
              color: '#f66',
              fontSize: '1.25rem',
              fontWeight: 700,
              borderRadius: 16,
              padding: '10px 0',
              textAlign: 'center',
              background: 'rgba(255,100,100,0.08)'
            }}
            onClick={() => { setLoggedIn(false); onClose(); }}
          >
            🚪 Wyloguj
          </div>
        )}
      </div>
    </div>
  );
}
// Menu.Login = Login;
export default Menu;
